import {NfMessage, NfMessageType} from "../NfMessage";
import {NfGlobalMessage} from "../NfGlobalMessage";
import {NfComponentGlobalMessage} from "../NfComponentGlobalMessage";


/**
 * Wiadomość, aby przeładować widgeta (np. po zmianie języka)
 */
export class ReloadBookingEngine extends NfComponentGlobalMessage {
    declare public keepServiceInstance: boolean;

    public constructor(keepServiceInstance: boolean | MessageEvent<ReloadBookingEngine>) {
        super(NfMessageType.ReloadBookingEngine, !NfMessage.isMessageEvent(keepServiceInstance));
        if (NfMessage.isMessageEvent(keepServiceInstance)) {
            Object.assign(this, keepServiceInstance.data);
        } else {
            this.keepServiceInstance = keepServiceInstance;
            if (!keepServiceInstance) {
                throw Error('keepServiceInstance is required');
            }
        }
    }

}
NfMessage.creationCallbacks[NfMessageType.ReloadBookingEngine] = (event) => {
    return new ReloadBookingEngine(event);
}
